module.exports = __webpack_public_path__ + "static/img/065_TO8_1629.fe3068f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/065_TO8_1629.jpg
// module id = /rms
// module chunks = 0